import style from '../style.module.css';
import Container from '~/components/common/container';
import Image from 'next/image';
import { NextLink, Translate, useTranslate } from '~/i18n';
import { PathEdge } from '~/svgs/business';
// import {  PathDown } from '~/svgs/business';
import cn from 'classnames';
// import { useState } from 'react';
// import BookingBottomsheet from './booking-bs';

/**
 * this component has a community section design
 */
const Booking = () => {
   const { translate } = useTranslate();
   // const [open, setOpen] = useState(false);
   // const handleClose = () => setOpen(false);

   const key_features = [
      {
         name: translate({ id: 'business:online ticketing' }),
         link: '/sell-event-tickets-online',
      },
      {
         name: translate({ id: 'business:offline ticketing' }),
         link: '/sell-event-tickets-offline',
      },
      {
         name: translate({ id: 'business:promotions and discounts' }),
         link: '/event-seat-map',
      },
      {
         name: translate({ id: 'business:referral engine' }),
      },
      {
         name: translate({ id: 'business:ticketing trucks' }),
      },
      {
         name: translate({ id: 'business:bank transfer capability' }),
      },
      {
         name: translate({ id: 'business:checkin app' }),
      },
      {
         name: translate({ id: 'business:real time unified dashboard' }),
      },
      {
         name: translate({ id: 'business:vip services' }),
      },
      {
         name: translate({ id: 'business:giveaways' }),
      },
      {
         name: translate({ id: 'business:wallet' }),
      },
      {
         name: translate({ id: 'business:event calendar' }),
      },
   ];

   const booking_infrastructure = [
      {
         category: translate({ id: 'business:marketing' }),
         list: [
            { name: translate({ id: 'business:marketing 1' }) },
            { name: translate({ id: 'business:marketing 2' }) },
            { name: translate({ id: 'business:marketing 3' }) },
            { name: translate({ id: 'business:marketing 4' }) },
            { name: translate({ id: 'business:marketing 5' }) },
            { name: translate({ id: 'business:marketing 6' }) },
            { name: translate({ id: 'business:marketing 7' }) },
            { name: translate({ id: 'business:marketing 8' }) },
         ],
         arrow: true,
      },
      {
         category: translate({ id: 'business:sales' }),
         list: [
            { name: translate({ id: 'business:sales 1' }) },
            { name: translate({ id: 'business:sales 2' }) },
            { name: translate({ id: 'business:sales 3' }) },
            { name: translate({ id: 'business:sales 4' }) },
            { name: translate({ id: 'business:sales 5' }) },
            { name: translate({ id: 'business:sales 6' }) },
            { name: translate({ id: 'business:sales 7' }) },
         ],
         arrow: true,
      },
      {
         category: translate({ id: 'business:pre event' }),
         list: [
            { name: translate({ id: 'business:pre event 1' }) },
            { name: translate({ id: 'business:pre event 2' }) },
            { name: translate({ id: 'business:pre event 3' }) },
            { name: translate({ id: 'business:pre event 4' }) },
            { name: translate({ id: 'business:pre event 5' }) },
            { name: translate({ id: 'business:pre event 6' }) },
         ],
         arrow: true,
      },
      {
         category: translate({ id: 'business:at event' }),
         list: [
            { name: translate({ id: 'business:at event 1' }) },
            { name: translate({ id: 'business:at event 2' }) },
            { name: translate({ id: 'business:at event 3' }) },
            { name: translate({ id: 'business:at event 4' }) },
            { name: translate({ id: 'business:at event 5' }) },
            { name: translate({ id: 'business:at event 6' }) },
            { name: translate({ id: 'business:at event 7' }) },
         ],
         arrow: true,
      },
      {
         category: translate({ id: 'business:post event' }),
         list: [
            { name: translate({ id: 'business:post event 1' }) },
            { name: translate({ id: 'business:post event 2' }) },
            { name: translate({ id: 'business:post event 3' }) },
            { name: translate({ id: 'business:post event 4' }) },
            { name: translate({ id: 'business:post event 5' }) },
         ],
         arrow: false,
      },
   ];
   return (
      <div className={`${style['yellow-bg']}`}>
         <Container className="text-white">
            <div className="hidden lg:flex items-center my-[83px]">
               <div className=" font-bold py-10  lg:text-[50px] ">
                  <Translate id="business:key features" />
               </div>
               <Image
                  src="/images/business/manage-your-event.png"
                  width="630.81px"
                  height="376px"
               />
            </div>
            <div className="lg:hidden items-center my-[40px]">
               <Image
                  src="/images/business/manage-your-event.png"
                  width="630.81px"
                  height="376px"
               />
               <div className=" font-bold pt-10  text-[30px] lg:text-[50px] ">
                  <Translate id="business:key features" />
               </div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-5.5">
               {key_features.map((feature, key) => (
                  <div key={key}>
                     <div className=" bg-[#0552BC] ltr:border-l-4 rtl:border-r-4 border-[#34D399] w-[182.19px] lg:w-[261.19px] h-[81.2px] lg:h-[100px] ltr:text-left rtl:text-right flex items-center px-3">
                        {feature.link ? (
                           <NextLink href={'/ticketing' + feature.link}>
                              <div className="  text-[16px] lg:text-[23px] font-semibold">
                                 {feature.name}
                              </div>
                           </NextLink>
                        ) : (
                           <div className="  text-[16px] lg:text-[23px] font-semibold">
                              {feature.name}
                           </div>
                        )}
                     </div>
                  </div>
               ))}
            </div>
            <div className="pt-[100px] pb-[80px]">
               <div className="text-[30px] lg:text-[50px] font-semibold lg:px-60">
                  <Translate id="business:our end" />
               </div>

               <div className="hidden lg:grid grid-cols-5 gap-5.5 pt-8">
                  {booking_infrastructure.map((value, key) => (
                     <div key={key}>
                        <div
                           className={cn(
                              'transform ltr:translate-x-16 rtl:-translate-x-44 translate-y-4  flex justify-end rtl:scale-x-[-1]',
                              !value.arrow && 'mt-14'
                           )}>
                           {value.arrow && <PathEdge className="py-1" />}
                        </div>
                        <div className=" bg-[#34D399]  p-6 px-3 rounded-2xl ltr:text-left rtl:text-right ">
                           <div className="  text-[23px] font-semibold lg:pt-4">
                              {value.category}
                           </div>
                        </div>
                        <div className="pt-8 px-1">
                           {value.list.map((value, key) => (
                              <div key={key} className="flex justify-items-start py-1">
                                 <li className="flex justify-start gap-[10px] ltr:text-left rtl:text-right list-none relative before:flex-shrink-0 before:mt-[7.5px] before:w-[5px] before:h-[5px] before:bg-white before:rounded-[50%]">
                                    {value.name}
                                 </li>
                              </div>
                           ))}
                        </div>
                     </div>
                  ))}
               </div>
               <div className=" lg:hidden pt-8">
                  {booking_infrastructure.map((value, key) => (
                     <div key={key}>
                        <div
                           // key={key}
                           // onClick={() => setOpen(true)}
                           className=" bg-[#34D399] rounded-2xl text-center mb-2">
                           <div className="  text-[23px] font-semibold py-4 ">{value.category}</div>
                        </div>

                        {/* <div className="flex justify-center">{value.arrow && <PathDown />}</div> */}
                        {/* <BookingBottomsheet key={key} open={open} handleClose={handleClose}>
                           <div className="pt-8 px-3">
                              {value.list.map((value, key) => (
                                 <div key={key} className="flex justify-items-start py-1">
                                    <li className="ltr:text-left rtl:text-right">{value.name}</li>
                                 </div>
                              ))}
                           </div>
                        </BookingBottomsheet> */}
                        <div className="pb-8 px-3">
                           {value.list.map((value, key) => (
                              <div key={key} className="flex justify-items-start py-1">
                                 <li className="ltr:text-left rtl:text-right">{value.name}</li>
                              </div>
                           ))}
                        </div>
                     </div>
                  ))}
               </div>
            </div>
         </Container>
      </div>
   );
};
export default Booking;
